import { ApplicationController } from "../../application_controller"
import ConfirmationDialogController from "../helpers/confirmation_dialog_controller"

export default class extends ApplicationController {
	confirmDestroy(event) {
		var confirmation_dialog_controller = new ConfirmationDialogController()
		confirmation_dialog_controller.show(event)
	}
}